<!--  -->
<template>
  <div>
    <el-table
      :data="fetchresData"
      border
      style="width: 100%;margin-bottom: 30px;"
    >
      <el-table-column
        prop="ipru"
        label="图文页的阅读人数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="iprc"
        label="图文页的阅读次数"
        align="center"
      />
      <el-table-column
        prop="opru"
        label="原文页的阅读人数"
        align="center"
      />
      <el-table-column
        prop="oprc"
        label="原文页的阅读次数"
        align="center"
      />
      <el-table-column
        prop="su"
        label="分享的人数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="sc"
        label="分享的次数"
        align="center"
      />
      <el-table-column
        prop="atfu"
        label="收藏的人数"
        align="center"
      />
      <el-table-column
        prop="atfc"
        label="收藏的次数"
        align="center"
      />
    </el-table>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="send_open_id_count"
        label="本次消息推送数"
        align="center"
        width="150"
      /> -->
      <el-table-column prop="send_open_id_count" label="" width="150" align="center">
        <template slot="header">
          本次消息推送数
          <el-tooltip class="item" effect="dark" content="订阅号的本次消息推送数量为1，实际上是推送了全部用户" placement="top">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="sent_count"
        label="发送成功的粉丝数"
        align="center"
        width="150"
      />
      <el-table-column
        prop="error_count"
        label="发送失败的粉丝数"
        align="center"
        width="150"
      />
      <!-- <el-table-column
        prop="publishId"
        label="发送任务id"
        width="180"
        align="center"
      /> -->
      <el-table-column
        prop="publish_status_text"
        label="发送结果"
        align="center"
        width="150"
      />
      <el-table-column
        prop="err_msg"
        label="失败原因"
        align="center"
        width="400"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="readser(scope.row.msg_data_id)">阅读统计</el-button>
          <el-button v-if="scope.row.status == 1" type="danger" size="mini" @click="deleterarticle(scope.row.msg_id,scope.row.app_id)">删除历史文章</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="阅读统计"
      :visible.sync="dialogVisibleread"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="75%"
    >
      <read ref="readview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { sendresults, fetchres, timingPushArtcdelete } from '@/api/sourceMaterial.js'
import read from './read.vue'
export default {
  components: {
    PaginationRight,
    read
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      id: null,
      dialogVisibleread: false,
      fetchresData: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.id = val
      this.resultlist()
    },
    async resultlist() {
      const data = await sendresults({
        ...this.pageIfon,
        id: this.id
      })
      this.tableData = data.data.list
      this.total = data.data.total
      this.fetchresData.push(data.data.sts_cnt)
      console.log('data', data)
      console.log('data---', this.fetchresData)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    async loojser(item) {
      const data = await fetchres({
        id: item
      })
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.resultlist()
      console.log('data', data)
    },
    readser(msg_data_id) {
      this.dialogVisibleread = true
      this.$nextTick(() => {
        this.$refs.readview.send(msg_data_id)
      })
    },
    deleterarticle(msg_id, app_id) {
      this.$confirm('确定要删除历史文章吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        timingPushArtcdelete({
          id: this.id,
          msg_id: msg_id,
          app_id: app_id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.resultlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
